export const STATUS_PELAKSANAAN = {
  BELUM_PENILAIAN: 'belum_penilaian',
  SEDANG_PENILAIAN: 'sedang_penilaian',
  HASIL_TERSAMPAIKAN: 'hasil_tersampaikan',
}

export const KATEGORI_PENILAIAN = {
  TAAT: 'taat',
  TAAT_DENGAN_CATATAN: 'taat_dengan_catatan',
  TIDAK_TAAT: 'tidak_taat',
}

export function createDummyPelaksanaan(provinceIds, currentYear) {
  const sortedProvinceIds = [...new Set(provinceIds.map(String))].sort()
  const records = []
  const statuses = Object.values(STATUS_PELAKSANAAN)
  const categories = Object.values(KATEGORI_PENILAIAN)

  for (let year = currentYear - 2; year <= currentYear; year += 1) {
    for (let month = 1; month <= 12; month += 1) {
      sortedProvinceIds.forEach((idProvinsi) => {
        const seed = year * 31 + month * 17 + Number(idProvinsi)

        // Reserve a known empty period for empty-state verification.
        if (year === currentYear - 2 && month === 12) return

        const recordCount = 3 + (seed % 6)
        for (let index = 0; index < recordCount; index += 1) {
          const status = statuses[(seed + index * 5) % statuses.length]
          const category = status === STATUS_PELAKSANAAN.HASIL_TERSAMPAIKAN
            ? categories[(seed + index) % categories.length]
            : null

          records.push({
            id: `${year}-${month}-${idProvinsi}-${String(index + 1).padStart(3, '0')}`,
            tahun: year,
            bulan: month,
            idProvinsi,
            status,
            kategori: category,
          })
        }
      })
    }
  }

  return records
}

export function emptyPelaksanaanSummary() {
  return {
    jumlahRencanaAksi: 0,
    belumPenilaian: 0,
    sedangPenilaian: 0,
    hasilTersampaikan: 0,
    penilaianPelaksanaan: 0,
    taat: 0,
    taatDenganCatatan: 0,
    tidakTaat: 0,
  }
}

export function summarizePelaksanaan(records) {
  const summary = emptyPelaksanaanSummary()
  summary.jumlahRencanaAksi = records.length

  records.forEach(({ status, kategori }) => {
    if (status === STATUS_PELAKSANAAN.BELUM_PENILAIAN) summary.belumPenilaian += 1
    if (status === STATUS_PELAKSANAAN.SEDANG_PENILAIAN) summary.sedangPenilaian += 1
    if (status === STATUS_PELAKSANAAN.HASIL_TERSAMPAIKAN) summary.hasilTersampaikan += 1

    if (kategori === KATEGORI_PENILAIAN.TAAT) summary.taat += 1
    if (kategori === KATEGORI_PENILAIAN.TAAT_DENGAN_CATATAN) summary.taatDenganCatatan += 1
    if (kategori === KATEGORI_PENILAIAN.TIDAK_TAAT) summary.tidakTaat += 1
  })

  summary.penilaianPelaksanaan = summary.taat + summary.taatDenganCatatan + summary.tidakTaat
  return summary
}
